module.exports = {"schedule":{"title":"Schedule","now_playing":"Now playing","empty":{"title":"Nothing found","detail":"There are no upcoming items to show"}}}